export default httpClient => ({
    save: async ({ dados, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/planos', dados, { headers });
        console.log(dados)
        return {
            data: response.data
        }
    },
    update: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/planos/' + dados.get('id'), dados, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/planos/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/planos', { headers });
        return {
            data: response.data
        }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/planos/' + id, { headers });
        return {
            data: response
        }
    },
    deletarImagem: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/deletar-imagem/' + id, { headers });
        return {
            data: response
        }
    },
});